const toastType = {
	success: "success",
	error: "error"
}

export default toastType
